import React from "react";
import { Search, X } from "lucide-react";
import { monthLabel } from "../../lib/events";

function Select({ value, onChange, options, placeholder, testid, dm }) {
  return (
    <select
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      data-testid={testid}
      className={`text-xs rounded-lg px-2.5 py-2 border-0 outline-none ${dm ? "bg-[#1a2324] text-slate-200" : "bg-white text-[#191c1d] shadow-sm"}`}
    >
      <option value="">{placeholder}</option>
      {options.map(([k, label, n]) => (
        <option key={k} value={k}>{label}{n !== undefined ? ` (${n})` : ""}</option>
      ))}
    </select>
  );
}

export function EventFilters({ filters, setFilter, clear, taxonomy, facets, dm, closingSoon }) {
  const opt = (map, counts) => Object.entries(map || {}).filter(([k]) => !counts || counts[k]).map(([k, label]) => [k, label, counts?.[k]]);
  const months = Object.keys(facets?.months || {}).sort().map((m) => [m, monthLabel(m), facets.months[m]]);
  const active = Object.keys(filters).length > 0;
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="event-filters">
      <label className={`flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 ${dm ? "bg-[#1a2324]" : "bg-white shadow-sm"}`}>
        <Search className={`w-3.5 h-3.5 ${dm ? "text-slate-500" : "text-[#96a4a8]"}`} />
        <input
          value={filters.q || ""}
          onChange={(e) => setFilter("q", e.target.value)}
          placeholder="Search name or city"
          data-testid="events-search-input"
          className={`text-xs bg-transparent outline-none w-36 sm:w-44 ${dm ? "text-slate-200 placeholder:text-slate-600" : "text-[#191c1d] placeholder:text-[#96a4a8]"}`}
        />
      </label>
      <Select dm={dm} testid="events-filter-region" value={filters.region} onChange={(v) => setFilter("region", v)} placeholder="All regions" options={opt(taxonomy?.regions, facets?.regions)} />
      <Select dm={dm} testid="events-filter-type" value={filters.type} onChange={(v) => setFilter("type", v)} placeholder="All types" options={opt(taxonomy?.types, facets?.types)} />
      <Select dm={dm} testid="events-filter-theme" value={filters.theme} onChange={(v) => setFilter("theme", v)} placeholder="All themes" options={opt(taxonomy?.themes, facets?.themes)} />
      <Select dm={dm} testid="events-filter-month" value={filters.month} onChange={(v) => setFilter("month", v)} placeholder="Any month" options={months} />
      <Select dm={dm} testid="events-filter-access" value={filters.access} onChange={(v) => setFilter("access", v)} placeholder="Any access" options={opt(taxonomy?.access, facets?.access)} />
      <button
        onClick={() => setFilter("closing", filters.closing ? "" : "1")}
        data-testid="events-filter-closing"
        className={`text-xs rounded-lg px-2.5 py-2 font-medium transition-colors ${filters.closing ? "bg-rose-500 text-white" : dm ? "bg-[#1a2324] text-slate-300" : "bg-white text-[#3b494c] shadow-sm"}`}
      >
        Registration closing soon{closingSoon ? ` (${closingSoon})` : ""}
      </button>
      {active && (
        <button onClick={clear} data-testid="events-filters-clear" className={`text-xs inline-flex items-center gap-1 px-2 py-2 ${dm ? "text-cyan-300" : "text-[#006874]"} hover:underline`}>
          <X className="w-3 h-3" /> Clear
        </button>
      )}
    </div>
  );
}

export default EventFilters;
